import { Provider } from '@angular/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

/** Angular Material global providers. */
export const materialProviders: readonly Provider[] = [{ provide: MAT_SELECT_CONFIG, useValue: { disableOptionCentering: true, hideSingleSelectionIndicator: true } }];
